import React from "react";
import { Modal } from "react-bootstrap";
import { updateCurrentUserRedux } from "../../../../api/helper";

export default ({ show, hide }) => {
  const handleClose = () => {
    updateCurrentUserRedux();
    hide();
    window.location.href = "/";
  };

  return (
    <Modal className="unsubscribe-primo-modal" show={show} onHide={handleClose} animation={true}>
      <Modal.Body className="text-center p-4 m-3">
        <p className="text-uppercase">Sorry to see you go!</p>
        <small>Your UNIFI Music account has been permanently deleted. You can always re-register for a new account at any time.</small>

        <div className="d-flex justify-content-center">
          <button variant="primary" className="btn btn-md btn-primary text-uppercase mt-3" onClick={handleClose}>
            GOT IT!
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
